import { render, staticRenderFns } from "./SoccerDepthChart.vue?vue&type=template&id=91bb0aba&"
import script from "./SoccerDepthChart.vue?vue&type=script&lang=ts&"
export * from "./SoccerDepthChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports